<template>
  <div>
    <el-row :gutter="15">
     
      <el-col >
        <el-card class="card">
          <div slot="header"
               class="card-header"><i class="el-icon-font el-icon-quyu el-icon--left"></i>区域</div>
          <div class="es-op-box">
            <el-input placeholder="请输入区域名称"
                      v-model="queryObj.keyWord"
                      size="small"
                      class="query"
                      style="float: left"
                      clearable
                      @change="()=>{this.queryObj.pageNum = 1;loadAreaTypeList()}">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button type="primary"
                       icon="el-icon-font el-icon-web__tianjia"
                       size="mini"
                       style="margin-right:6px"
                       @click="add_init">新增</el-button>
            <es-delete @del="del()"
                       type="button"></es-delete>
          </div>
          <el-table :data="pageData.list"
                    ref="areaTable"
                    border
                    stripe
                    size="mini"
                    height="calc(100vh - 250px)"
                    v-loading="loading">
            <el-table-column type="selection"
                             width="40"
                             align="center">
            </el-table-column>
            <el-table-column type="index"
                             label="序号"
                             width="50"
                             align="center">
            </el-table-column>
            <el-table-column prop="name"
                             label="区域类型名称">
            </el-table-column>
            <el-table-column prop="code"
                             label="区域类型编码">
            </el-table-column>            
            <el-table-column label="操作"
                             width="80"
                             align="center">
              <template slot-scope="scope">
                <el-link :underline="false"
                         title="编辑"
                         @click="edit_init(scope.row)"
                         type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <es-delete @del="del(scope.row.id)"
                           type="icon"
                           :key="scope.row.id"></es-delete>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData"
                           @change="(cpage)=>{this.queryObj.pageNum=cpage;this.loadAreaTypeList()}">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!--编辑区域-->
    <el-dialog :visible.sync="editVisible"
               @closed="()=>this.$refs['areaTypeForm'].clearValidate()"
               width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑区域类型
      </span>
      <el-form :model="areaTypeInfo"
               :rules="rules"
               size="mini"
               label-position="right"
               label-width="150px"
               ref="areaTypeForm">
        <el-form-item prop="name"
                      label="区域名称">
          <el-input v-model="areaTypeInfo.name"
                    placeholder="请输入区域名称"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="code"
                      label="区域编码">
          <el-input v-model="areaTypeInfo.code"
                    placeholder="请输入区域编码"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>       
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="editVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submitArea()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'assetareatype',
  props: ["funcs"],
  data () {
    return {      
      queryObj: { pageNum: 1, pageSize: 20 },//查询条件
      pageData: {},
      editVisible: false,
      areaTypeInfo: {},//区域信息
      rules: {//验证条件
        name: [
          { required: true, message: '请输入区域名称', trigger: 'blur' },
          { max: 50, message: '不能超过50个字符', trigger: 'blur' }
        ],       
        code: [
          { required: true, message: '请输入区域编码', trigger: 'blur' },
          { max: 50, message: '不能超过50个字符', trigger: 'blur' }
        ]
      },
      loading: false,
      saving: false
    }
  },
  methods: {
    //页面初始化
    init () {
      this.loadAreaTypeList()
    },   
    queryAreaList (orgIds) {
      this.queryObj.pageNum = 1
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(',')
      }
      this.loadAreaTypeList()
    },

    //从后台查询区域列表
    loadAreaTypeList () {
      this.loading = true
      this.$ajax.get('/base/areatype/list', this.queryObj).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    //初始化添加区域
    add_init () {
      this.editVisible = true
      this.areaTypeInfo = {}
    },
    //初始化编辑区域
    edit_init (row) {
      this.editVisible = true
      this.areaTypeInfo = JSON.parse(JSON.stringify(row))
    },
    //保存区域信息
    submitArea () {
      this.$refs["areaTypeForm"].validate(valid => {
        if (valid) {
          let url = "/base/areatype/add";
          if (this.areaTypeInfo.id != null) {
            url = "/base/areatype/edit";
          }       
          this.saving = true
          this.$ajax.post(url, this.areaTypeInfo).then(msg => {
            this.saving = false
            this.loadAreaTypeList()
            this.editVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除区域信息
    del (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["areaTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/base/areatype/delete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadAreaTypeList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
</style>
